<template>
  <NavQuestion
    v-bind:heading="'Advice Page'"
    v-bind:background="'bg-desk'"
    v-bind:questionOptions="true"
  >
    <template v-slot:contents> </template>
    <template v-slot:navButtons>
      <NavQuestionButtons
        v-bind:validated="true"
        v-bind:forwardText="'Share'"
        v-bind:forwardLink="'/share'"
      ></NavQuestionButtons>
    </template>
  </NavQuestion>
</template>

<script>
import NavQuestionButtons from '@/common/ui/NavQuestionButtons'
import NavQuestion from '@/common/ui/NavQuestion'

export default {
  name: 'AdvicePage',
  components: {
    NavQuestionButtons,
    NavQuestion
  },
  beforeRouteLeave(to, from, next) {
    this.$emit('closeAdviceModal')
    next()
  },
  mounted() {
    this.$emit('showAdviceModalCheckout')
    this.$store.commit('checkoutProgress', {
      pay: true,
      createWill: true,
      package: true,
      printing: true,
      checking: true
    })
  },
  computed: {},
  data() {
    return {}
  },
  methods: {}
}
</script>
